import { z } from "zod/v4";
//#region src/schemas/config/agent-activity-route-registry.ts
const AGENT_ACTIVITY_ROUTE_REGISTRY_VERSION = 1;
const agentActivityRouteRegistrySchema = z.strictObject({
	routes: z.array(z.strictObject({ rootDir: z.string().trim().min(1).max(4096) })).max(64),
	version: z.literal(1)
}).superRefine((value, context) => {
	const rootDirs = /* @__PURE__ */ new Set();
	for (const [index, route] of value.routes.entries()) {
		if (rootDirs.has(route.rootDir)) context.addIssue({
			code: "custom",
			message: "Agent Activity route roots must be unique.",
			path: [
				"routes",
				index,
				"rootDir"
			]
		});
		rootDirs.add(route.rootDir);
	}
});
//#endregion
export { AGENT_ACTIVITY_ROUTE_REGISTRY_VERSION, agentActivityRouteRegistrySchema };

//# sourceMappingURL=agent-activity-route-registry.js.map